<template>
  <div class="big">
    <div class="page_title">辅料通用名</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="search-box">
          <div class="search-item">
            <span>名称</span>
            <el-input
              v-model="searchForm.material_name"
              placeholder="请输入"
              size="small"
              clearable
              style="width: 200px; margin-left: 12px"
            ></el-input>
          </div>
          <div class="search-item">
            <span>分类</span>
            <el-select
              v-model="searchForm.material_type"
              placeholder="请选择"
              size="small"
              clearable
              style="width: 200px; margin-left: 12px"
            >
              <el-option
                v-for="item in typeList"
                :key="item.material_type"
                :label="item.material_type_name"
                :value="item.material_type"
              ></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <el-button type="primary" size="small" @click="getList"
              >查询</el-button
            >
            <el-button
              type="primary"
              size="small"
              style="margin-left: 10px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2049') : false
              "
              @click="openAddDialog"
              >新增</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6; margin-top: 20px">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="名称" prop="material_name">
            </el-table-column>
            <el-table-column label="分类" prop="material_type_name">
            </el-table-column>
            <el-table-column label="单位" prop="material_unit" width="200">
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('2050')
                      : false
                  "
                  @click="openEditDialog(scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 新增/编辑弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formRef"
        label-width="80px"
        style="padding: 20px"
      >
        <el-form-item label="名称" prop="material_name">
          <el-input
            v-model="form.material_name"
            placeholder="20个字以内,不可重复"
            maxlength="20"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="material_type">
          <el-select
            v-model="form.material_type"
            placeholder="请选择"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in typeList"
              :key="item.material_type"
              :label="item.material_type_name"
              :value="item.material_type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位" prop="material_unit">
          <el-select
            v-model="form.material_unit"
            placeholder="请选择"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in unitList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import dayjs from "dayjs";
import template from "@/api/template";
import common from "@/api/common";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      searchForm: {
        material_name: "",
        material_type: "",
      },
      typeList: [],
      unitList: [],
      dialogVisible: false,
      dialogTitle: "新增",
      form: {
        tcm_id: "",
        material_name: "",
        material_type: "",
        material_unit: "",
      },
      rules: {
        material_name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { max: 20, message: "不能超过20个字符", trigger: "blur" },
        ],
        material_type: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        material_unit: [
          { required: true, message: "请选择单位", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getTypeList();
    this.getUnitList();
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      this.tableLoading = true;
      const params = {
        material_name: this.searchForm.material_name || "",
        material_type: this.searchForm.material_type || "",
        page: this.pagination.page,
        pageNumber: this.pagination.pageNumber,
      };
      template
        .materialTcmList(params)
        .then((res) => {
          if (res.code === 0) {
            this.tableData = res.data.list || [];
            this.totalNum = res.data.total || 0;
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 获取分类列表
    getTypeList() {
      template.goodsMaterialType({}).then((res) => {
        if (res.code === 0) {
          this.typeList = res.data.list || [];
        }
      });
    },
    // 获取单位列表
    getUnitList() {
      common.goodsMaterialUnit({}).then((res) => {
        if (res.code === 0 && res.data && Array.isArray(res.data.list)) {
          this.unitList = res.data.list.map((item) => {
            // 接口返回格式: {name: "g"}
            const unitName = item.name || "";
            return {
              label: unitName,
              value: unitName,
            };
          });
        }
      });
    },
    // 打开新增弹框
    openAddDialog() {
      this.dialogTitle = "新增";
      this.form = {
        tcm_id: "",
        material_name: "",
        material_type: "",
        material_unit: "",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    // 打开编辑弹框
    openEditDialog(row) {
      this.dialogTitle = "编辑";
      this.form = {
        tcm_id: row.tcm_id,
        material_name: row.material_name,
        material_type: row.material_type,
        material_unit: row.material_unit,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const params = {
            material_name: this.form.material_name,
            material_type: this.form.material_type,
            material_unit: this.form.material_unit,
          };
          let apiMethod = "materialTcmAdd";
          if (this.form.tcm_id) {
            // 编辑
            apiMethod = "materialTcmUpdate";
            params.tcm_id = this.form.tcm_id;
          }
          const loading = this.$loading();
          template[apiMethod](params)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success("操作成功");
                this.dialogVisible = false;
                this.getList();
              } else {
                if (res.message && res.message.includes("已存在")) {
                  this.$message.error("名称已存在");
                } else {
                  this.$message.error(res.message || "操作失败");
                }
              }
            })
            .catch((err) => {
              console.error(err);
              this.$message.error("操作失败");
            })
            .finally(() => {
              loading.close();
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.search-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  .search-item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    span {
      white-space: nowrap;
    }
  }
}
</style>